import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const ForbiddenPage = () => {
  return (
    <Box sx={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", py: 6 }}>
      <Container maxWidth="sm">
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Access denied
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          You do not have permission to view this page (403). If you believe this is a mistake, contact your study
          coordinator.
        </Typography>
        <Button variant="contained" component={RouterLink} to="/">
          Go to home
        </Button>
      </Container>
    </Box>
  );
};

export default ForbiddenPage;
